import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';

const ProspectDecisionDialog = ({ open, mode, onCancel, onConfirm, isSaving }) => {
  const isApprove = mode === 'approve';

  return (
    <Dialog open={open} onClose={isSaving ? undefined : onCancel} fullWidth maxWidth='sm'>
      <DialogTitle>{isApprove ? 'Approve prospect?' : 'Revoke approval?'}</DialogTitle>
      <DialogContent>
        {isApprove ? (
          <Typography variant='body2'>Once approved, Lead Agents can start engaging with this prospect.</Typography>
        ) : (
          <>
            <Typography variant='body2' mb={1.5}>
              This prospect will move back to Pending and the Lead Agent will no longer be able to engage with this
              prospect unless you approve it again.
            </Typography>
            <Typography variant='body2'>
              This does not affect any commission eligibility already earned by the Lead Agent for opening the
              opportunity.
            </Typography>
          </>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} color='secondary' disabled={isSaving}>
          Cancel
        </Button>
        <Button onClick={onConfirm} variant='contained' color={isApprove ? 'success' : 'error'} disabled={isSaving}>
          {isApprove ? 'Approve' : 'Revoke approval'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ProspectDecisionDialog;
